import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
    analyticsCardEmploymentRejectedClickBack,
    analyticsCardEmploymentRejectedClickDashboardFooter,
} from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import CardEmploymentRejected from '@perpay-web/fintech/components/composite/CardEmploymentRejected/CardEmploymentRejected';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { noop } from '@perpay-web/utils/noop';

const CardEmploymentRejectedContainer = ({
    onClickBack = noop,
    isPHO = false,
}) => {
    const dispatch = useDispatch();

    const clickBackHandler = useCallback(() => {
        dispatch(analyticsCardEmploymentRejectedClickBack());
        onClickBack();
    }, [dispatch, onClickBack]);

    const onClickDashboard = useCallback(
        () => dispatch(analyticsCardEmploymentRejectedClickDashboardFooter()),
        [dispatch],
    );

    const dashboardURL = isPHO
        ? `${paths.dashboard.path}?PHO_complete=true`
        : paths.dashboard.path;

    return (
        <CardEmploymentRejected
            onClickBack={clickBackHandler}
            onClickDashboard={onClickDashboard}
            dashboardURL={dashboardURL}
        />
    );
};

export default CardEmploymentRejectedContainer;
